  import React from "react";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
  import { faFilePdf, faRoadCircleCheck } from "@fortawesome/free-solid-svg-icons";
  import "./HomeCertificado.css";
  import { useTranslation } from "react-i18next";

  const CardCertificado = () => {
    const { t } = useTranslation();

    return (
      <section id="certificados-section" className="certificados-section text-center py-5">
        <h2 className="certificados-title mb-4">{t("homeCertificados.title")}</h2>

        <div className="certificado-card mx-auto p-4 shadow">
          <div className="certificado-icon">
            <FontAwesomeIcon icon={faRoadCircleCheck} className="pb-4"/>
          </div>
          <h3 className="certificado-nome mb-4 pt-5">{t("homeCertificados.certificado1.name")}</h3>

          <a
            href="/pdfs/iatfMgsul.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-certificado d-inline-flex align-items-center gap-2"
          >
            <FontAwesomeIcon icon={faFilePdf} />
            {t("homeCertificados.certificado1.button")}
          </a>
        </div>
      </section>
    );
  };

  export default CardCertificado;
